<template>
	<div class="full-page-container d-flex flex-column align-center justify-center text-center">
		<v-col cols="11" md="7" lg="4">
			<h1 class="text-h2 font-weight-regular white--text mb-10">Oops, that link isn’t working.</h1>
			<h3 class="text-h4 font-weight-regular white--text">
				We couldn’t find the page you’re looking for. You might want to ask the sender for help.
			</h3>
		</v-col>
		<img class="bottom-left-image" src="@/assets/ls-contact-3d-color-logo-white-font.svg" alt="Logo" />
	</div>
</template>

<script lang="ts">
	export default {
		name: "PageNotFound",
	};
</script>

<style scoped>
	.full-page-container {
		background: url("@/assets/ls-contact-wallpaper.svg");
		background-size: cover;
		background-position: center;
		min-height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 100000;
	}

	.bottom-left-image {
		position: absolute;
		bottom: 10px;
		left: 10px;
	}
</style>
